import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import ArrowIcon from '../_assets/arrow-icon.svg'

import courseLogic from '~/scenes/course/show/logic'

const Arrow = () => (
  <div className='arrow-icon-container'>
    <img className='arrow-icon' alt='arrow icon' src={`${ArrowIcon}`} width={12} height={12} />
  </div>
)

export default function Breadcrumbs () {
  const {
    course: {
      breadcrumbs: { root, categories }
    }
  } = useValues(courseLogic)

  return (
    <div className='breadcrumbs-container'>
      <div className='breadcrumb-root'>
        <a href={root.url}>{root.title}</a>
      </div>
      <Arrow />
      {categories.map((category, index) => (
        <React.Fragment key={category.id}>
          <div className='breadcrumb-child'>
            <a href={category.url}>
              <em>{category.title}</em>
            </a>
          </div>
          {index < categories.length - 1 && <Arrow />}
        </React.Fragment>
      ))}
    </div>
  )
}
